/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DepartmentWard from './department-ward';
import DepartmentWardDetail from './department-ward-detail';
import DepartmentWardUpdate from './department-ward-update';
import DepartmentWardDeleteDialog from './department-ward-delete-dialog';

const DepartmentWardRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DepartmentWard />} />
    <Route path="new" element={<DepartmentWardUpdate />} />
    <Route path=":id">
      <Route index element={<DepartmentWardDetail />} />
      <Route path="edit" element={<DepartmentWardUpdate />} />
      <Route path="delete" element={<DepartmentWardDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DepartmentWardRoutes;
